import React from 'react';
import PropTypes from 'prop-types';
import { useCssProps } from '@uhg-abyss/web/hooks/useCssProps';
import { classNames } from '@uhg-abyss/web/tools/classNames';

import { baseStyles } from './PageLayout.styles';

export const PageLayout = ({ className, styles, ...props }) => {
  const classes = useCssProps(baseStyles, null, styles);
  return <div {...props} className={classNames(classes.layout, className)} />;
};

PageLayout.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.shape({}),
};

PageLayout.defaultProps = {
  className: null,
  styles: null,
};
